<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <span class="mr-2">{{ function_name }} </span>
      </div>
    </div>

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div>{{ _.get(request_form, 'ftie_id', '') }} </div>
          </div>
          <div class="header-col">
            <div>Vertical</div>
            <div>{{ _.get(request_form, 'vertical', '') }} </div>
          </div>
          <div class="header-col">
            <div>Price</div>
            <div>{{ _.get(request_form, 'price', '') }} </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Request Form ID</div>
            <div>
              {{ _.get(request_form, 'uni_id', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>Create Date</div>
            <div>{{ _.get(request_form, 'create_date', '') | dateTimeFormat}} </div>
          </div>
          <div class="header-col">
            <div>Status</div>
            <div>{{ _.get(request_form, 'status', '') }} </div>
          </div>

        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Project</div>
            <div>{{ _.get(request_form, 'project', '') }}</div>
          </div>
          <div class="header-col">
            <div>Qty</div>
            <div>{{ _.get(request_form, 'qty', '') }}</div>
          </div>
          <div class="header-col">
            <div>Create by</div>
            <div>{{ _.get(request_form, 'create_by', '') }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Proposal Sharepoint Url</div>
            <div v-if="_.get(request_form, 'customization_proposal_url', '') !=='' &&_.get(request_form, 'customization_proposal_url', '') !=null"> <a class="link" target="_blank" :href="safeUrl(`${ _.get(request_form, 'customization_proposal_url', '')}`)">{{ _.get(request_form, 'model', '') }};FTIE ID{{ _.get(request_form, 'ftie_id', '') }};Request Form ID{{ _.get(request_form, 'uni_id', '') }} </a></div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Complete Date</div>
            <div v-if="_.get(tl_approval, 'last_update_date', '') !=='' &&_.get(tl_approval, 'last_update_date', '') !=null"> {{_.get(tl_approval, 'last_update_date', '') | dateFormat}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--#endregion -- Header ---->
    <!--#region -- Body ---->
    <div class="caption-label">RD Function
      <div class="ml-3 mb-1 d-print-none">
        <b-button @click="assignRdCheckItem" class="btn btn-primary btn-sm min-w-4" variant="primary">Assign</b-button>
        <!--<b-button v-b-modal.update-request-form class="btn btn-primary btn-sm min-w-4" variant="primary">Update</b-button>
        <b-modal centered id="update-request-form" title="Update TL comment or complete date" ok-title="save" @ok="updateRequestForm">
          <div class="header-col validate">
            Please update the complete date or approval comments.
          </div>
          <b-row class="mt-2">
            <b-col sm="5">
              <label for="textarea-subject">Comments Options</label>
            </b-col>
            <b-col sm="1">
              :
            </b-col>
            <b-col sm="6">
              <b-form-select :options="tl_comments_option" label="TL Comments:" @change="handleInputChange"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="5">
              <label for="textarea-subject">TL Comments</label>
            </b-col>
            <b-col sm="1">
              :
            </b-col>
            <b-col sm="6">
              <gtc-textarea v-model="fesc_tl_comment" />
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col sm="5">
              <label for="textarea-description">Proposal Complete Date</label>
            </b-col>
            <b-col sm="1">
              :
            </b-col>
            <b-col sm="6">
              <b-form-datepicker v-model="proposal_complete_date" :dropdown-append-to-body="true"></b-form-datepicker>
            </b-col>
          </b-row>
        </b-modal>-->
      </div>
    </div>
    <div v-if="feas_function !=null" class="table-responsive" style="min-height: 2.5rem;">
      <b-table :fields="fields" :items="feas_function.feas_functions"
               small
               thead-class="thead-light text-dark"
               style="width: calc(100% - 10px)">

        <template #cell(owner)="data">
          <b-form-select v-model="data.item.rd_check_item_owner"
                         :options="filterBelongMember(data.item.function_name, data.item.sub_function_name)"></b-form-select>
        </template>
        <template #cell(action)="data">
          <div class="col-auto align-self-end" style="width: 11.5rem">
            <b-button variant="primary" data-toggle="collapse" aria-expanded="false" @click="data.toggleDetails"
                      v-b-tooltip.hover.rightbottom title="Collapse for sub ticket">Detail</b-button>
            <a v-if="data.item.rd_check_item_uni_id != null" :class="{'btn btn-primary':checkRdSolution(data.item.rd_check_item_uni_id)===true, 'btn btn-danger':checkRdSolution(data.item.rd_check_item_uni_id)===false}"
               target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/rd-check-item/${ $route.params.ftie_id}/${ $route.params.request_form_id}`)">Sol.</a>
          </div>
        </template>
        <template #row-details="data">
          <ul>
            <li v-for="detail, index in filterBelongDetail(data.item.uni_id)" :key="index">{{detail.check_item}}</li>
          </ul>
        </template>

      </b-table>
    </div>
    <!--#endregion -- Body ---->
  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'assign-rd-function',
    data() {
      return {
        function_name: 'Reuqest Form Info',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        login_user_name: null,
        fields: [
          { key: 'function_name', label: 'Function Name', thClass: 'align-middle', sortable: false },
          { key: 'sub_function_name', label: 'Sub Function Name', thClass: 'align-middle', sortable: false },
          { key: 'owner', label: 'Owner', thClass: 'align-middle', sortable: false },
          { key: 'action', label: 'Action', thClass: 'align-middle', thStyle: { width: '6%' }, sortable: false },
        ],
        feas_function: null,
        request_form: null,
        tl_approval: null,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        tl_comments_option: [
          'Goto Kickoff directly.',
          'Need Feasibility check meeting with PM',
          'Create PN/BOM directly.',
          'Feasibility check directly.',
          'Other Comments'
        ],
        proposal_complete_date: null,
        fesc_tl_comment: null
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      if (self.login_user_name !== 'albert.chen') {
        self.$message.warning('No acees permission', self.function_name);
        //window.location.href = self.$root.frontEndUrl + '/ftie/ftie-dashboard';
        window.location.href = self.frontEndUrlToUse + 'ftie/ftie-dashboard';
      }
      self.getFunctions();

    },
    computed: {
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
    },
    methods: {
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },

      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;


      },
      getFunctions() {
        let self = this;
        let ftie_id = self.$route.params.ftie_id;
        let request_form_id = self.$route.params.request_form_id;
        let url = self.$root.baseUrl + `/ftie/rd-check-function/`;

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          ftie_id: encodeURI(ftie_id),
          request_form_id: encodeURI(request_form_id)
        };

        let feas_function = null;
        let request_form = null;
        eventHub.$emit('loading', true);
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              feas_function = JSON.parse(res['rd_function_obj']);
              request_form = JSON.parse(res['request_form']);
              self.tl_approval = _.find(JSON.parse(res['request_form_approvals']), { approval_function: 'FESC TL' });

              console.log(feas_function);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.feas_function = feas_function;
            self.request_form = request_form;
            eventHub.$emit('loading', false);
          })
      },
      filterBelongMember(function_name, sub_function_name) {
        let self = this;
        let members = []

        _.each(_.filter(self.feas_function.feas_function_members, item => { return item.function_name === function_name && item.sub_function_name === sub_function_name; }), item => {

          let member = {
            value: item.gulid,
            text: item.user_name,
            mail: item.cc_mail_name
          };
          members.push(member)
        });
        return members
      },
      filterBelongDetail(function_id) {
        let self = this;
        return _.filter(self.feas_function.feas_details, item => { return item.sub_function_id === function_id })
      },
      checkRdSolution(uni_id) {
        let self = this;
        let rd_check_item = _.find(self.feas_function.rd_check_items, { uni_id: uni_id });
        let check_result = false;
        if (rd_check_item !== null) {
          if (rd_check_item.special_list !== null || rd_check_item.schedule_m_d !== null || rd_check_item.man_power !== null) {
            check_result = true;
          }
        }
        return check_result;
      },
      assignRdCheckItem() {
        let self = this;
        let insert_rd_check_items = [];
        let update_rd_check_items = [];

        _.each(_.filter(self.feas_function.feas_functions, item => { return item.rd_check_item_owner !== null; }), item => {
          if (item.rd_check_item_uni_id === null) {
            let insert_rd_check_item = {
              uni_id: null,
              ftie_id: self.request_form.ftie_id,
              create_by: self.login_user_name,
              sub_function_id: item.uni_id,
              sub_function_name: item.sub_function_name,
              owner: item.rd_check_item_owner,
              request_form_id: self.request_form.uni_id
            };
            insert_rd_check_items.push(insert_rd_check_item);
          } else {
            let exist_rd_check_item = _.find(self.feas_function.rd_check_items, { uni_id: item.rd_check_item_uni_id });
            if (exist_rd_check_item !== null) {
              if (exist_rd_check_item.owner !== item.rd_check_item_owner) {
                let update_rd_check_item = {
                  uni_id: item.rd_check_item_uni_id,
                  owner: item.rd_check_item_owner,
                  old_owner: exist_rd_check_item.owner
                };
                update_rd_check_items.push(update_rd_check_item);
              }

            } else {
              let insert_rd_check_item = {
                ftie_id: self.request_form.ftie_id,
                create_by: self.login_user_name,
                sub_function_id: item.uni_id,
                sub_function_name: item.sub_function_name,
                owner: item.rd_check_item_owner,
                request_master_id: self.request_form.uni_id
              };
              insert_rd_check_items.push(insert_rd_check_item);
            }
          }
        });
        console.log(insert_rd_check_items);
        console.log(update_rd_check_items);
        let url = self.$root.baseUrl + '/ftie/rd-check-function/';
        let request_data = {
          insert_rd_check_items: insert_rd_check_items,
          update_rd_check_items: update_rd_check_items,
          request_form_id: self.request_form.uni_id,
          ftie_id: self.request_form.ftie_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {

                //window.location = this.$root.frontEndUrl + '/ftie/assign-rd-function' + '/' + encodeURIComponent(self.$route.params.ftie_id) + '/' + encodeURIComponent(self.$route.params.request_form_id);
                window.location = this.frontEndUrlToUse + 'ftie/assign-rd-function' + '/' + encodeURIComponent(self.$route.params.ftie_id) + '/' + encodeURIComponent(self.$route.params.request_form_id);
              }

            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      handleInputChange(event) {
        let self = this;
        self.fesc_tl_comment = event;
      },
      updateRequestForm() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/update-request-form-approval/';
        let temp_date = null;
        if (self.proposal_complete_date) {
          temp_date = moment(self.proposal_complete_date).format('YYYY-MM-DD');
        }
        let request_data = {
          request_form_id: self.request_form.uni_id,
          proposal_complete_date: temp_date,
          update_comments: self.fesc_tl_comment,
          ftie_id: self.request_form.ftie_id,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                self.$message.info('Save success!');
              } else {
                self.$message.exception('Save fail!');
              }

            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.getFunctions();
          })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_AssignRdFunction.vue